import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ModmedIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M16 5.75c5.66 0 10.25 4.59 10.25 10.25S21.66 26.25 16 26.25 5.75 21.66 5.75 16 10.34 5.75 16 5.75Zm.04 16.793a.75.75 0 0 1-1.45.007l-2.017-7.446-1.346 4.53a.752.752 0 0 1-.718.537H8.306A8.749 8.749 0 0 0 16 24.75a8.749 8.749 0 0 0 7.694-4.58h-2.53a.751.751 0 0 1-.723-.549l-1.873-6.75-2.528 9.672ZM16 7.25a8.75 8.75 0 0 0-8.333 11.42h2.281l1.94-6.523.045-.115a.75.75 0 0 1 1.397.133l1.97 7.274 2.521-9.64a.751.751 0 0 1 1.448-.01l2.465 8.882h2.599A8.75 8.75 0 0 0 16 7.25Z"
      fill={preserveColor ? '#502D7F' : undefined}
    />
  </BaseIcon>
);
